import React from 'react'

const FCPayModeWise = () => {
  return (
    <div>FCPayModeWise</div>
  )
}

export default FCPayModeWise